import { useState, useEffect } from 'react';
import cn from 'classnames';

import Container from './Container';

export const LoadingPage = ({ loadingText = 'Loading...' }) => (
  <Container className="text-3xl font-bold text-white">{loadingText}</Container>
);

export const LoadingDots = ({ className }: { className?: string }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setTimeout(() => setIndex((index + 1) % 3), 400);
    return () => clearTimeout(id);
  }, [index]);

  return (
    <div className={cn('inline-flex justify-center', className)}>
      <div
        style={{ opacity: index === 0 ? 1 : index === 1 ? 0.6 : 0.2 }}
        className="w-1.5 h-1.5 mr-1 bg-white rounded-full transition-opacity ease duration-200"
      />
      <div
        style={{ opacity: index === 1 ? 1 : index === 2 ? 0.6 : 0.2 }}
        className="w-1.5 h-1.5 mr-1 bg-white rounded-full transition-opacity ease duration-200"
      />
      <div
        style={{ opacity: index === 2 ? 1 : index === 0 ? 0.6 : 0.2 }}
        className="w-1.5 h-1.5 bg-white rounded-full transition-opacity ease duration-200"
      />
    </div>
  );
};
